import React from "react";
import { LayoutSettings } from "../../../../../boxes/LayoutSettings/LayoutSettings";
import styles from "./styles.module.scss";
import { Header } from "./shared/Header";
import { useData } from "./hooks/useData";
import { Table } from "./shared/Table";

export const All = () => {
  const { searchFilter, statuses, handlers, data } = useData();

  return (
    <LayoutSettings contentClassName={styles.root}>
      <Header searchFilter={searchFilter} />
      <Table statuses={statuses} handlers={handlers} data={data} />
    </LayoutSettings>
  );
};
